import { ChangeDetectorRef, Component, inject, OnInit, signal, ChangeDetectionStrategy, DOCUMENT } from '@angular/core';
import { TierFeaturesModel } from '../../../models/layout/tier-features-model';
import { RouterModule } from '@angular/router';
import { LocalizationService } from '../../../Services/localization-service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-tier-features-component',
  imports: [
    RouterModule
  ],
  templateUrl: './tier-features-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './tier-features-component.scss'
})
export class TierFeaturesComponent implements OnInit {
  private readonly localizationService = inject(LocalizationService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translateService = inject(TranslateService);
  private readonly document = inject(DOCUMENT);
  currentLang = environment.defaultLang;
  tierFeaturesModel: TierFeaturesModel = {
    tierFeatures: [
      {
        order: 1,
        productId: '5A6F5F15-B872-4496-B88F-89B845A6911B',
        priceString: this.translateService.instant('TierFeatures1PriceString'),
        buttonText: this.translateService.instant('TierFeaturesButtonText'),
        description: this.translateService.instant('TierFeatures1Description'),
        discountPercentage: 16.66,
        highLighted: false,
        highLightLabel: '',
        isEnabled: true,
        subTitle: this.translateService.instant('TierFeatures1SubTitle'),
        title: this.translateService.instant('TierFeatures1Title'),
        items: [
          {
            icon: '',
            order: 1,
            text: this.translateService.instant('TierFeatures1item1')
          },
          {
            icon: '',
            order: 2,
            text: this.translateService.instant('TierFeatures1item2')
          },
          {
            icon: '',
            order: 3,
            text: this.translateService.instant('TierFeatures1item3')
          },
          {
            icon: '',
            order: 4,
            text: this.translateService.instant('TierFeatures1item4')
          },
          {
            icon: '',
            order: 5,
            text: this.translateService.instant('TierFeatures1item5')
          },
          {
            icon: '',
            order: 6,
            text: this.translateService.instant('TierFeatures1item6')
          },
        ]
      },
      {
        order: 2,
        productId: 'D8D3B09E-0B46-4001-B033-FF82ECBA0570',
        priceString: this.translateService.instant('TierFeatures2PriceString'),
        buttonText: this.translateService.instant('TierFeaturesButtonText'),
        description: this.translateService.instant('TierFeatures2Description'),
        discountPercentage: 16.66,
        highLighted: false,
        highLightLabel: '',
        isEnabled: true,
        subTitle: this.translateService.instant('TierFeatures2SubTitle'),
        title: this.translateService.instant('TierFeatures2Title'),
        items: [
          {
            icon: '',
            order: 1,
            text: this.translateService.instant('TierFeatures2item1')
          },
          {
            icon: '',
            order: 2,
            text: this.translateService.instant('TierFeatures2item2')
          },
          {
            icon: '',
            order: 3,
            text: this.translateService.instant('TierFeatures2item3')
          },
          {
            icon: '',
            order: 4,
            text: this.translateService.instant('TierFeatures2item4')
          },
          {
            icon: '',
            order: 5,
            text: this.translateService.instant('TierFeatures2item5')
          },
          {
            icon: '',
            order: 6,
            text: this.translateService.instant('TierFeatures2item6')
          },
          {
            icon: '',
            order: 7,
            text: this.translateService.instant('TierFeatures2item7')
          },
          {
            icon: '',
            order: 8,
            text: this.translateService.instant('TierFeatures2item8')
          },
          {
            icon: '',
            order: 9,
            text: this.translateService.instant('TierFeatures2item9')
          },
        ]
      },
      {
        order: 3,
        productId: '2270EF4D-BF3F-4BB3-BC03-D16AADB076C8',
        priceString: this.translateService.instant('TierFeatures3PriceString'),
        buttonText: this.translateService.instant('TierFeaturesButtonText'),
        description: this.translateService.instant('TierFeatures3Description'),
        discountPercentage: 16.66,
        highLighted: true,
        highLightLabel: '',
        isEnabled: true,
        subTitle: this.translateService.instant('TierFeatures3SubTitle'),
        title: this.translateService.instant('TierFeatures3Title'),
        items: [
          {
            icon: '',
            order: 1,
            text: this.translateService.instant('TierFeatures3item1')
          },
          {
            icon: '',
            order: 2,
            text: this.translateService.instant('TierFeatures3item2')
          },
          {
            icon: '',
            order: 3,
            text: this.translateService.instant('TierFeatures3item3')
          },
          {
            icon: '',
            order: 4,
            text: this.translateService.instant('TierFeatures3item4')
          },
          {
            icon: '',
            order: 5,
            text: this.translateService.instant('TierFeatures3item5')
          },
          {
            icon: '',
            order: 6,
            text: this.translateService.instant('TierFeatures3item6')
          },
          {
            icon: '',
            order: 7,
            text: this.translateService.instant('TierFeatures3item7')
          },
          {
            icon: '',
            order: 8,
            text: this.translateService.instant('TierFeatures3item8')
          },
          {
            icon: '',
            order: 9,
            text: this.translateService.instant('TierFeatures3item9')
          },
        ]
      }
    ],
    title: this.translateService.instant('TierFeaturesTitle'),
    text1: this.translateService.instant('TierFeaturesText1'),
    text2: this.translateService.instant('TierFeaturesText2'),
    text3: this.translateService.instant('TierFeaturesText3')
  }


  ngOnInit(): void {

    this.localizationService.getLanguage().subscribe(lang => {
      if (lang != '') {
        this.currentLang = lang;
        const canonicalUrl = `${this.document.location.origin}/${lang}/blogs`;
        this.updateCanonicalUrl(canonicalUrl);
        this.cdr.detectChanges();
      }

    });
  }
  private updateCanonicalUrl(canonicalUrl: string): void {
    let link = this.document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }

    link.setAttribute('href', canonicalUrl);
  }
}